import React, { Component } from 'react';
import { Modal, Button, ModalBody } from 'react-bootstrap';
import boost from '../../assets/img/boost.svg'
import axios from 'axios';
import BoostPlan from '../commoncomponents/boostpaymentplan';
import PaymentPending from '../main/plan/paymentpending';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class BoostActivate extends Component {
    constructor(props) {
        super(props);
        this.useBoostModal = this.useBoostModal.bind(this); 
        this.state = {
            api_url: localStorage.getItem('api_url'),
            superlikeplanmodal: false,
            activatedBoostModel: false,
            boost_details: '',
            paymentpendingmodal: false,
        };
    }

    componentDidMount() {
        var profile = new FormData();
        profile.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
        profile.append('language', this.state.langKey);

        axios({
            method: 'post',
            url: this.state.api_url + 'webcheckboost',
            data: profile,
            headers: {'Content-Type': 'multipart/form-data'}
        }).then(res => {
            if (res.data.status === "true") {
                this.setState({
                    boost_cashpayment: res.data.boost_cashpayment,
                    boostStatus: 'activated',
                    boostCount: res.data.boost_count
                });
            } else {
                this.setState({
                    boost_cashpayment: res.data.boost_cashpayment,
                    boostStatus: 'available',
                    boostCount: res.data.boost_count
                });
            }
        }).catch(error => {
            console.error('Error checking boost:', error);
        });
    }

    useBoostModal() { 
        if (this.state.boostStatus !== 'activated' && this.state.boostCount > 0) {
            var profile = new FormData();
            profile.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
            profile.append('language', this.state.langKey);
            axios({
                method: 'post',
                url: this.state.api_url + 'webactivateboost',
                data: profile,
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(res => {
                const message = res.data.message || 'Boost activated successfully!'; 
                this.setState({
                    boostCount: res.data.boost_count,
                    successMessage: message,
                    activatedBoostModel: true
                });
                this.props.handleClose();
            }).catch(error => {
                console.error('Error activating boost:', error);
            });
        } else if (this.state.boostStatus === 'activated') {
            this.setState({
                successMessage: "Boost activated currently",
                activatedBoostModel: true
            });
            this.props.handleClose();
        } else if(this.state.boost_cashpayment === '1'){
            this.props.handleClose();
            this.handlePaymentPendingOpenModal();
        } else {
            this.props.handleClose();
            this.setState({ boostplanmodal: true });
        }
    }

    handleBoostPlanCloseModal = () => {
        this.setState({ boostplanmodal: false });
    }

    activatedcloseBoostModel = () => {
        window.location.reload();
        this.setState({ activatedBoostModel: false });
    }

    handlePaymentPendingOpenModal = () => {
        this.setState({ paymentpendingmodal: true });
    }

    handlePaymentPendingCloseModal = () => {
        this.setState({ paymentpendingmodal: false });
    }

    render() {
        return (
            <>
                <div className="">
                    <Modal className="modal_div boostplan_modal" show={this.props.showModal} onHide={this.props.handleClose} centered>
                        <Modal.Body className="religion_modal">
                            <div className='boostplan_img'>
                                <img src={boost} alt="img" />
                            </div>
                            <div className='boostplan_content'>
                                <h4>{this.state.boostCount} Remaining</h4>
                                <p>
                                    <Trans i18nKey="You're being seen by more people.">You're being seen by more people.</Trans>
                                    <br/>
                                    <Trans i18nKey="Keep swiping for the best result.">Keep swiping for the best result.</Trans></p>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="forgot_button_plr boostplan_activate boostplan_button">
                            <Button className='button_primary ' onClick={this.useBoostModal}>
                                <Trans i18nKey="Boost is active">Boost is active</Trans>
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={this.state.activatedBoostModel} className="modal_div joinplan_modal" >
                        <Modal.Body className="religion_modal paymentsuccess_modal">
                            <div className=''>
                                <p>{this.state.successMessage}</p>
                            </div>
                       </Modal.Body>
                        <Modal.Footer className="paymentsuccess_okBtn">
                            <Button className='button_primary' onClick={this.activatedcloseBoostModel}>
                                <Trans i18nKey="Ok">Ok</Trans>
                            </Button>
                        </Modal.Footer>  
                    </Modal>

                </div>
                
                <BoostPlan
                    showModal={this.state.boostplanmodal}
                    handleClose={this.handleBoostPlanCloseModal}
                />

                <PaymentPending
                    showModal={this.state.paymentpendingmodal}
                    handleClose={this.handlePaymentPendingCloseModal}
                />
            </>
        );
    }
}

export default BoostActivate;
